<div class="div-conten-center">
  <div mat-dialog-title>
    <mat-icon class="mat-icon-modal mat-icon-modal-{{data.result}}">{{ data.icon }}</mat-icon>
  </div>
  <div mat-dialog-content class="mat-dialog-generic-message">
    <p>{{ data.message }}</p>
  </div>
  <div mat-dialog-actions>
    <button mat-button *ngIf="data.btAccept" class="bt-general bt-action" (click)="cancelWithAction()">
      Aceptar
    </button>
    <button mat-button *ngIf="data.btCancel" class="bt-general bt-cancel" (click)="cancelModal()" cdkFocusInitial>
      Cancelar
    </button>
  </div>
</div>